/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-05-29 14:27
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-09-02 09:14
 * @FilePath: \solis_storage_cloud_web\src\router\login.js
 * @Description: 登录前的路由
 */
// import i18n from '@/lang' // 导入你的 i18n 实例
// const t = i18n.global.t
export default [
  {
    path: '/homepage',
    redirect: to => {
      console.log("🚀 ~ to:", to)
      return ({ path: '/login', query: to.query })
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: {
      // title: "",// 标题
      routeAuthCode: false, // 不需要登录验证
      // keepAlive: false, // 不需要缓存
      authorityCode: null, // 权限码
    }
  },
  {
    path: '/thirdLogin',
    name: 'thirdLogin',
    component: () => import('../views/thirdPartyLogin/index.vue'),
    meta: {
      // title: "",// 标题
      routeAuthCode: false, // 不需要登录验证
      // keepAlive: false, // 不需要缓存
      authorityCode: null, // 权限码
    }
  },
  {
    path: '/modify_password',
    name: 'modify_password',
    component: () => import('../views/login/modifyPassword.vue'),
    meta: {
      // title: "",// 标题
      routeAuthCode: false, // 不需要登录验证
      // keepAlive: false, // 不需要缓存
      authorityCode: null, // 权限码
    }
  },
  {
    path: '/invalidToken',
    name: 'invalidToken',
    component: () => import('../views/error/invalidToken.vue'),
    meta: {
      // title: "",// 标题
      routeAuthCode: false, // 不需要登录验证
      authorityCode: null, // 权限码
    }
  },
]
